import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  hasRole,
  isSuperAdmin,
  canAccessMenu
} from '@/helpers/permissions'

/**
 * Permission mixin for Vue components
 * Provides permission checking methods in any component
 *
 * Usage:
 * import permissionMixin from '@/mixins/permissionMixin'
 *
 * export default {
 *   mixins: [permissionMixin],
 *   // ...
 * }
 *
 * Then in template or methods:
 * v-if="$can('admin.users.list')"
 * v-if="$canAny(['admin.users.list', 'admin.users.add'])"
 */
export default {
  methods: {
    /**
     * Check if user has a specific permission
     * @param {string} permission - Permission name
     * @returns {boolean}
     */
    $can (permission) {
      return hasPermission(permission)
    },

    /**
     * Check if user has any of the specified permissions
     * @param {string[]} permissions - Array of permission names
     * @returns {boolean}
     */
    $canAny (permissions) {
      return hasAnyPermission(permissions)
    },

    /**
     * Check if user has all of the specified permissions
     * @param {string[]} permissions - Array of permission names
     * @returns {boolean}
     */
    $canAll (permissions) {
      return hasAllPermissions(permissions)
    },

    /**
     * Check if user has a specific role
     * @param {string} role - Role name
     * @returns {boolean}
     */
    $hasRole (role) {
      return hasRole(role)
    },

    /**
     * Check if user is Super Admin
     * @returns {boolean}
     */
    $isSuperAdmin () {
      return isSuperAdmin()
    },

    /**
     * Check if user can access a menu link
     * @param {string} link - Menu link
     * @returns {boolean}
     */
    $canAccessMenu (link) {
      return canAccessMenu(link)
    }
  }
}
